"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewDataTypesEnum = void 0;
var ReviewDataTypesEnum;
(function (ReviewDataTypesEnum) {
    ReviewDataTypesEnum["ALL"] = "all";
    ReviewDataTypesEnum["VALID"] = "valid";
    ReviewDataTypesEnum["INVALID"] = "invalid";
})(ReviewDataTypesEnum = exports.ReviewDataTypesEnum || (exports.ReviewDataTypesEnum = {}));
